


import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';


import "./i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading....</div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
/*

  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <div className="body_curtain"></div>
      <Menu />
      <Hero />
      <About />
      <Projects />
      <Contact />
    </I18nextProvider>
  </React.StrictMode>

*/
